"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useValidation = exports.useValidatedState = exports.ValidationHint = void 0;
var react_1 = require("react");
var Validate_1 = require("./Validate");
var Focus_1 = require("../labels/Focus");
var ValidationHint;
(function (ValidationHint) {
    ValidationHint[ValidationHint["NoValidation"] = 0] = "NoValidation";
    ValidationHint[ValidationHint["ClearValidation"] = 1] = "ClearValidation";
})(ValidationHint || (exports.ValidationHint = ValidationHint = {}));
function useValidatedState(initialState, schema) {
    var _a = (0, react_1.useState)(initialState), value = _a[0], setValue = _a[1];
    return __spreadArray([value], useValidation(schema, value, setValue), true);
}
exports.useValidatedState = useValidatedState;
function useValidation(schema, value, onChange) {
    var _this = this;
    var _a = (0, react_1.useState)({}), errors = _a[0], setErrors = _a[1];
    var valueRef = (0, react_1.useRef)(null);
    var validateInternal = function (v, errors, paths) { return __awaiter(_this, void 0, void 0, function () {
        var _a, newErrors, original, allErrors, _i, paths_1, p;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    valueRef.current = v;
                    return [4, (0, Validate_1.validate)(schema, v, paths)];
                case 1:
                    _a = _b.sent(), newErrors = _a[0], original = _a[1];
                    if (valueRef.current != original) {
                        throw { cancelled: true };
                    }
                    if (!paths) {
                        setErrors(newErrors);
                    }
                    else {
                        allErrors = __assign(__assign({}, errors), newErrors);
                        for (_i = 0, paths_1 = paths; _i < paths_1.length; _i++) {
                            p = paths_1[_i];
                            if (p in newErrors) {
                                continue;
                            }
                            delete allErrors[p];
                        }
                        setErrors(allErrors);
                    }
                    return [2, Object.keys(newErrors).length == 0];
            }
        });
    }); };
    var setValueState = function (v, hint) {
        var newValue = __assign(__assign({}, value), v);
        onChange(newValue);
        if (hint == ValidationHint.ClearValidation) {
            setErrors({});
        }
        else if (hint == ValidationHint.NoValidation) {
        }
        else {
            var paths = void 0;
            if (typeof hint == 'object') {
                paths = hint.map(function (r) { return r.toString(); }).filter(function (r) { return (r ? true : false); });
            }
            else {
                paths = [];
                for (var p in v) {
                    paths.push(p);
                }
            }
            validateInternal(newValue, errors, paths);
        }
    };
    var revalidate = function (container) { return __awaiter(_this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, validateInternal(value, errors)];
                case 1:
                    res = _a.sent();
                    if (!res) {
                        setTimeout(function () { return (0, Focus_1.validationFocus)(container); }, 1);
                    }
                    return [2, res];
            }
        });
    }); };
    return [setValueState, errors, revalidate];
}
exports.useValidation = useValidation;
//# sourceMappingURL=ValidatedState.js.map